<template>
  <v-dialog
    v-model="dialog"
    width="400px">
    <div class="header flex">
      <p>Hold Dollar Activity Detail</p>
      <font-awesome-icon
        icon="times"
        class="close"
        @click="handleCancel"></font-awesome-icon>
    </div>
    <div class="body">
      <div
        class="main">
        <div class="action">{{action}}</div>
        <div
          v-for="(val, i) in arr"
          :key="i"
          class="tr">
          <div class="left">{{val.title}}</div>
          <div class="right">{{info[val.value]}}</div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import {getTranscriptsDetail} from '@/api/refer'
import MixinOptions from '@/mixins/options'
export default {
  name: 'HolddollarDetail',
  mixins: [MixinOptions],
  props:{
    detailData:{
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      dialog: false,
      action_id: 0,
      id: 0,
      info: {},
      action1:[
        {
          title: 'Date',
          value: 'issue_date'
        },
        {
          title: 'Referre',
          value: 'referee'
        },
        {
          title: 'Insurance Type Name',
          value: 'insurance_type_language'
        },
        {
          title: 'Hold Dollars',
          value: 'point'
        },
      ],
      action2:[
        {
          title: 'Request Date',
          value: 'request_date'
        },
        {
          title: 'Status',
          value: 'status_language'
        },
        {
          title: 'Account Holder\'s Name',
          value: 'card_holder'
        },
        {
          title: 'Bank Name',
          value: 'card_bank'
        },
        {
          title: 'Bank Account Number',
          value: 'card_number'
        },
        {
          title: 'Transfer Amount',
          value: 'money'
        },
        {
          title: 'Holdcover Paid',
          value: 'hc_paid'
        },
        {
          title: 'Transferred Date',
          value: 'transferred_date'
        },
        {
          title: 'Transcripts',
          value: 'transfer_file'
        },
        {
          title: 'Reference Number',
          value: 'point'
        },
      ],
      action3:[
        {
          title: 'Date',
          value: 'issue_date'
        },
        {
          title: 'Policy Reference Code',
          value: 'policy_number'
        },
        {
          title: 'Insurance Type',
          value: 'insurance_type_language'
        },
        {
          title: 'Hold Dollars',
          value: 'point'
        },
      ],
      action4:[
        {
          title: 'Date',
          value: 'issue_date'
        },
        {
          title: 'Reference Code',
          value: 'policy_number'
        },
        {
          title: 'Insurance Type',
          value: 'insurance_type_language'
        },
        {
          title: 'Hold Dollars',
          value: 'point'
        },
      ],
      action5:[
        {
          title: 'Date',
          value: 'issue_date'
        },
        {
          title: 'Hold Dollars',
          value: 'point'
        },
      ],
      action6:[
        {
          title: 'Date',
          value: 'issue_date'
        },
        {
          title: 'Campaign',
          value: 'campaign_name'
        },
        {
          title: 'Hold Dollars',
          value: 'point'
        },
      ],
      action8:[
        {
          title: 'Date',
          value: 'issue_date'
        },
        {
          title: 'Referee',
          value: 'name'
        },
        {
          title: 'Activity',
          value: 'referral_name'
        },
        {
          title: 'Hold Dollars',
          value: 'point'
        },
      ],
      action11:[
        {
          title: 'Date',
          value: 'issue_date'
        },
        {
          title: 'Hold Dollars',
          value: 'point'
        },
      ],
      action12:[
        {
          title: 'Date',
          value: 'request_date'
        },
        {
          title: 'Redeem Crypto',
          value: 'currency'
        },
        {
          title: 'Rate',
          value: 'price'
        },
        {
          title: 'Hold Dollars',
          value: 'money'
        },
        {
          title: 'BUSD',
          value: 'hc_paid'
        }
      ],
      action13:[
        {
          title: 'Date',
          value: 'success_date'
        },
        {
          title: 'Hold Dollars Amount',
          value: 'premium'
        },
        {
          title: 'Exchange Item',
          value: 'product_language'
        },
        {
          title: 'Exchange Amount',
          value: 'premium_str'
        },

      ],
      action14:[
        {
          title: 'Date',
          value: 'success_date'
        },
        {
          title: 'Hold Dollars',
          value: 'point'
        },
        {
          title: 'CS',
          value: 'cs'
        },
        {
          title: 'Reason',
          value: 'reason'
        },
        {
          title: 'Remarks',
          value: 'remarks'
        }
      ],
      action18:[
        {
          title: 'Date',
          value: 'issue_date'
        },
        {
          title: 'Team Member',
          value: 'team_member'
        },
        {
          title: 'Insurance Type',
          value: 'insurance_type_language'
        },
        {
          title: 'Extra Team Bonus',
          value: 'point'
        },
      ],
      action19:[
        {
          title: 'Date',
          value: 'created_date'
        },
        {
          title: 'Delayed Flight',
          value: 'flight_no'
        },
        {
          title: 'Hold Dollars',
          value: 'point'
        },
      ],
      action16:[
        {
          title: 'Date',
          value: 'success_date'
        },
        {
          title: 'Hold Dollars',
          value: 'point'
        },
      ],
      action17:[
        {
          title: 'Date',
          value: 'success_date'
        },
        {
          title: 'Hold Dollars',
          value: 'point'
        },
      ],
      action25:[
        {
          title: 'Date',
          value: 'issue_date'
        },
        {
          title: 'Policyholder',
          value: 'policyholder'
        },
        {
          title: 'Insurance Type',
          value: 'insurance_type_language'
        },
        {
          title: 'Hold Dollars',
          value: 'point'
        },
        {
          title: 'Ref.',
          value: 'ref_no'
        },
      ],
      action26:[
        {
          title: 'Date',
          value: 'issue_date'
        },
        {
          title: 'Team Member',
          value: 'team_member'
        },
        {
          title: 'Policyholder',
          value: 'policyholder'
        },
        {
          title: 'Insurance Type',
          value: 'insurance_type_language'
        },
        {
          title: 'Hold Dollars',
          value: 'point'
        },
        {
          title: 'Ref.',
          value: 'ref_no'
        },
      ],
    }
  },
  computed:{
    action(){
      return this.getOptionName('creditAction', this.action_id)
    },
    arr(){
      let action = this.action_id==15?1:this.action_id
      if([22,23,24].includes(this.action_id)){
        action = 18
      }
      let arr = this[`action${action}`]
      let arr_last = [{
        title: 'Ref.',
        value: 'ref_no'
      }]
      if([1,15,16,17,18,19].includes(action))
      {
        arr = [...arr,...arr_last]
      }
      return  arr
    }
  },
  watch:{
    detailData:{
      immediate: true,
      deep: true,
      handler(val){
        if(val.id){
          this.id = val.id
          this.action_id = val.action
          // 因为列表搜索aciton为6的数据时返回的却是aciton为10，后端说逻辑没问题，所以只能我这边手动改啦，到时候如果有action为10的选项再另行处理吧
          if(val.action == 10){
            this.action_id = 6
          }
          this.network().getTranscriptsDetail()
        }
      }
    }
  },
  methods: {
    changeDialog(){
      this.dialog = !this.dialog
    },
    handleCancel(){
      this.changeDialog()
    },
    network(){
      return {
        getTranscriptsDetail: async () => {
          const {data} = await getTranscriptsDetail({
            action: this.action_id,
            transcript_id: this.id
          })
          this.info = data
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
/deep/.el-dialog{
  border-radius: 6px;
  .header{
    background: #F6F8FA;
    border: 1px solid #E1E4E8;
    border-radius: 6px 6px 0px 0px;
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    p{
      font-weight: 600;
      font-size: 14px;
      height: 20px;
      color: #1B1F23;
    }
    .close{
      padding: 0 5px;
      cursor: pointer;
    }
  }
  .body{
    padding: 20px 15px 15px 15px;
    .main{
      .action{
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: #24292E;
        margin-bottom: 20px;
      }
      .tr{
        display: flex;
        .left{
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          color: #24292E;
          margin-right: 15px;
          width: 150px;
        }
        .right{
          font-weight: 600;
          font-size: 12px;
          line-height: 18px;
          color: #6A737D;
          overflow-wrap: break-word;
          flex: 1;
        }
      }
    }
  }
}
</style>
